module.exports = __webpack_public_path__ + "static/media/AlwynNewRounded_Regular.637ddeff.woff";